import React, { useState } from "react";
import { useWatchState } from "@/store";
import { checkResult, createFilePath } from "@/common";
import { BaseService, RemindService, uploadUrl } from "@/service";
import moment from "moment";
import { FileList, Upload } from "@/components";
import { Modal, Button, Form, Input, message, Icon } from "antd";

const { TextArea } = Input;
const TABLE_NAME = "feedback";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};

const App = Form.create({ name: 'register' })((props) => {

    const { getFieldDecorator } = props.form;

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [[{ title = "反馈", show, hide, width = 800, vo = {}, state, contrast, callback, defaultData = {} }]] = useWatchState(["modal.feedbackFormV2"])

    const add = async vo => {
        const add_time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        setLoading(true);
        const res = await BaseService.add({ table: TABLE_NAME, data: { ...vo, add_time } });
        setLoading(false);
        if (!checkResult(res.data)) return;

        const { id } = res.data.result;
        const remindRes = await RemindService.add({ cheese_id: id, ai: 1, remind_start_time: add_time, ai_stage: 1 });
        if (!checkResult(remindRes)) return;

        message.success("添加成功！");
        hide();
        if (callback) callback();
    }

    const put = async values => {
        const update_time = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        let vo = contrast(values, ["id"]);
        setLoading(true);
        const res = await BaseService.put({ table: TABLE_NAME, data: { ...vo, update_time }, where: { id: vo.id } });
        setLoading(false);
        if (!checkResult(res)) return;
        message.success("修改成功！");
        hide();
        if (callback) callback();
    }

    const funs = { add, put }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                funs[state](values);
            }
        });
    };

    const onUploadFileFinish = (e) => {
        setFiles([...files, ...e.file.response.files.map(({ fileShowName, url }) => ({ name: fileShowName, url }))])
    }
    const onRemoveFile = (e) => {
        console.log(e);
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={handleSubmit}>
                <Form.Item label="联系方式">
                    {getFieldDecorator('phone', {
                        initialValue: defaultData.phone,
                        rules: [
                            {
                                required: true,
                                message: '请输入联系方式！',
                            },
                        ],
                    })(<Input placeholder="请输入联系方式" />)}
                </Form.Item>
                <Form.Item label="姓名">
                    {getFieldDecorator('name', {
                        initialValue: defaultData.name,
                        rules: [
                            {
                                required: true,
                                message: '请输入姓名！',
                            },
                        ],
                    })(<Input placeholder="请输入姓名" />)}
                </Form.Item>
                <Form.Item label="反馈意见">
                    {getFieldDecorator('remark', {
                        initialValue: defaultData.remark,
                        rules: [
                            {
                                required: true,
                                message: '请输入反馈意见！',
                            },
                        ],
                    })(<TextArea rows={3} placeholder="请输入反馈意见" />)}
                </Form.Item>
                <Form.Item label="附件">
                    <FileList data={files.map((o) => ({ ...o, url: createFilePath(o.url, UPLOAD_SERVER_HOST) }))} onRemove={onRemoveFile} />
                    <Upload
                        name="files"
                        className="full"
                        onFinish={onUploadFileFinish}
                        action={uploadUrl}
                        showUploadList={false}>
                        <button className="com-feedback__file-btn" type="button"><Icon type="plus" /></button>
                    </Upload>
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
})

export default App;